import React from 'react';

import {Grid, List, ListItem, Typography, Link, CircularProgress, Divider} from '@mui/material';

export default function ItemsList({tyot, loading}) {
  return (
		<>
		{loading === true ?
				<CircularProgress />
		:
		<List>
			{tyot?.map((tyo) => {
				return (
					<div>
					<ListItem key={tyo.id}>
						<Grid container justify="center" spacing={4}>
							<Grid sx={{display: 'flex', alignItems: {xs: 'left', xl: 'center'}, justifyContent: 'left'}} item xs={5} sm={5} md={3} lg={3} xl={2}>
								<Typography variant="body4" sx={{display: 'flex', justifyContent: 'center', fontWeight: '800', wordBreak: 'break-word', fontSize: {xs: '11px', sm: '16px'}}}>{tyo.otsikko}</Typography>
							</Grid>
							<Grid sx={{display: 'flex', alignItems: 'center', justifyContent: 'left'}} item xs={3} sm={3} md={2.25} lg={1.75} xl={1.25}>
								<Typography variant="body4" sx={{display: 'flex', justifyContent: 'center', wordBreak: 'break-word', fontSize: {xs: '11px', sm: '16px'}}}>{tyo.tyyppi}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', md: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} md={2.25} lg={1.75} xl={1.25}>
								<Typography variant="body4">{tyo.organisaatio}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', md: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} md={1.5} lg={1} xl={1}>
								<Typography align="center" variant="body4">{tyo.vuosi === 0 ? "n.d." : tyo.vuosi}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', lg: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item md={0} lg={1.5} xl={1.25}>
								<Typography variant="body4">{tyo.tekijat}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', lg: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item md={0} lg={1.5} xl={1.25}>
								<Typography variant="body4">{tyo.teemat}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', xl: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} xl={1.5}>
								<Typography variant="body4">{tyo.kohderyhmat}</Typography>
							</Grid>
							<Grid sx={{display: {xs: 'none', xl: 'flex'}, alignItems: 'center', justifyContent: 'left'}} item xs={0} xl={1.25}>
								<Typography variant="body4">{tyo.tieteenala}</Typography>
							</Grid>
							<Grid sx={{display: 'flex', alignItems: 'center', justifyContent: 'left'}} item xs={3} sm={3} md={2} lg={1.5} xl={1.25}>
								<Link target="_blank" href={tyo.linkki} rel="noreferrer" variant="body4" sx={{display: 'flex', justifyContent: 'center', fontSize: {xs: '11px', sm: '16px'}}}>{tyo.saatavuus}</Link>
							</Grid>
						</Grid>
					</ListItem>
					<Divider variant="fullWidth" component="li" />
					</div>
				)
			})}
		</List>
		}
		</>
  );
}